import React from "react";

const HBusinessCard = ({ logo, name, description }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="h-16 w-16 overflow-hidden rounded-full">
        <img
          src={logo || "/placeholder.svg"}
          alt={name}
          className="h-full w-full object-cover"
          onError={e => {
            e.target.onerror = null;
            e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`;
          }}
        />
      </div>
      <h4 className="mt-2 text-sm font-medium">{name}</h4>
      <p className="text-xs text-gray-500">{description}</p>
    </div>
  );
};

export default HBusinessCard;
